export const IS_CREATE_PRODUCT_PAGE = 'is-create-product-page'
export const PRODUCT_ID = 'product-id'
